export const EVENT_CHORD_PRODUCT_ADD_TO_CART = 'chord_product_add_to_cart';
export const EVENT_CHORD_PRODUCT_REMOVE_FROM_CART = 'chord_product_remove_from_cart';
export const EVENT_CHORD_CART_PAGE_VIEW = 'chord_cart_page_view';
